import React, { Component } from "react";
import Form from 'components/Form';
import locale from '../locale';
import moment from 'moment';
import getClockTime from 'controllers/teacher/getClockTime';
import { alert } from 'util/alert';
import SalaryModal from 'template/Modals/Salary';

class ClockCardStatistic extends Component {
  constructor(props){
    super(props)
    this.state = {
      clockCardData: {
        work_dates: [
          { value: '1', label: __('Monday', locale) },
          { value: '2', label: __('Tuesday', locale) },
          { value: '3', label: __('Wednesday', locale) },
          { value: '4', label: __('Thursday', locale) },
          { value: '5', label: __('Friday', locale) },
        ],
        work_start_time: moment('9:00 am', 'h:mm a'),
        work_end_time: moment('5:00 pm', 'h:mm a')
      },
      clockCardStatistic: null,
      totalPrice: 0
    }
    this.onChange = this.onChange.bind(this);
    this.getStatistic = this.getStatistic.bind(this);
    this.calculateSalary = this.calculateSalary.bind(this);
  }
  onChange(value){
    this.setState({clockCardData: value});
  }
  getStatistic(){
    const schoolId = localStorage.getItem('schoolId');
    const { startDate, endDate, teacherId } = this.props;
    const { clockCardData } = this.state;
    const { work_dates, work_start_time, work_end_time } = clockCardData;
    const validation = this.validate();
    if(moment(work_start_time).isBefore(work_end_time)){
      if(validation.ok){
        let weekday = work_dates.map((item)=> item.value);
        getClockTime(schoolId, {
          page: 1,
          start_date: startDate,
          end_date: endDate || moment().format('YYYY-MM-DD'),
          teacher: teacherId,
          statistics: 1,
          weekday,
          start_work_time: moment(work_start_time).format('HH:mm'),
          end_work_time: moment(work_end_time).format('HH:mm') 
        })
          .then((res)=>{
            if(res){
              this.setState(prevState =>{
                if(prevState.clockCardStatistic !== res){
                  return {...prevState, clockCardStatistic: res, totalPrice: 0}
                }
              })
            }
          })
      }
    }else {
      alert.warning(__('Work End Time must be later than Work Start Time', locale))
    }
  }
  calculateSalary(){
    SalaryModal({statistics: this.state.clockCardStatistic, salaryCalculatorType: 'clockCard'})
    .then(({data})=>{
      if(data) {
        this.setState({totalPrice: data})
      } else {
        this.setState({totalPrice: 0});
      }
    })
    .catch((e) => {})
  }
  render() {
    const schema = [
      {
        name: 'work_dates',
        label: __('Working Days', locale),
        type: 'weekdateSelect',
        required: true,
      },
      {
        name: 'work_start_time',
        label: __('Work Start Time', locale),
        type: 'timepicker',
        required: true,
      },
      {
        name: 'work_end_time',
        label: __('Work End Time', locale),
        type: 'timepicker',
        required: true,
      },
    ];
    const { clockCardData, clockCardStatistic, totalPrice } = this.state;
    const { isShow } = this.props;
    return (
      <div className='clockInOut-modal-content' style={{display: isShow? 'block': 'none'}}>
        <Form
          onChange={this.onChange}
          schema={schema}
          formData={clockCardData}
          formStyle='outline'
          getValidationRef={(ref)=>this.validate=ref}
        />
        <div className='statistic-btn-wrapper'>
          <button className='btn btn-primary statistic' onClick={this.getStatistic}>
            {__('Get Statistic', locale)}
          </button>
        </div>
        { clockCardStatistic && 
          <div className='statistic-container'>
            <div className='statistic-items-wrapper'>
              <div className='item-label'><span>{__('Total Work Duration', locale)}:</span><span className='statistic-count'>{clockCardStatistic.work_duration} {__('h', locale)}</span></div>
              <div className='item-label'><span>{__('Abnormal Amount', locale)}:</span><span className='statistic-count'>{clockCardStatistic.abnormal_amount} {__('times', locale)}</span></div>
            </div>
            <div className='statistic-items-wrapper'>
              <div className='item-label'><span>{__('Absent Amount', locale)}:</span><span className='statistic-count'>{clockCardStatistic.absent_amount} {__('times', locale)}</span></div>
              <div className='item-value'><span>{__('Absent Duration', locale)}:</span><span className='statistic-count'>{clockCardStatistic.absent_duration} {__('h', locale)}</span></div>
            </div>
            <div className='statistic-items-wrapper'>
              <div className='item-label'><span>{__('Late Amount', locale)}:</span><span className='statistic-count'>{clockCardStatistic.late_amount} {__('times', locale)}</span></div>
              <div className='item-value'><span>{__('Late Duration', locale)}:</span><span className='statistic-count'>{clockCardStatistic.late_duration} {__('h', locale)}</span></div>
            </div>
            <div className='statistic-items-wrapper'>
              <div className='item-label'><span>{__('Leave Early Amount', locale)}:</span><span className='statistic-count'>{clockCardStatistic.leave_early_amount} {__('times', locale)}</span></div>
              <div className='item-value'><span>{__('Leave Early Duration', locale)}:</span><span className='statistic-count'>{clockCardStatistic.leave_early_duration} {__('h', locale)}</span></div>
            </div>
            <div className='total-salary-wrapper'>
              <button className='btn btn-primary calculate' onClick={this.calculateSalary}>
                {__('Calculate Salary', locale)}
              </button>
              <div>{__('Total Salary', locale)}</div>
              <div className='total-salary'>${parseFloat(totalPrice).toFixed(2)}</div>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default ClockCardStatistic;


// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/Statistics/clockCardStatistic.js